<script>
  import Container from '@/Elements/Containers/FullCentred.svelte';
  import Preview from '@/Elements/Shapes/Cards/Preview.svelte';
  import Text from '@/Elements/Signals/Dark/Text/Base.svelte';
  import Header from '@/Elements/Signals/Dark/Headers/Small.svelte';
  import Meta from '@/Elements/Signals/Dark/Meta/XXSmall.svelte';

  export let relation;

  let message = relation.message;
  let person = relation.person;
  let project = relation.project;
  let img = relation.img;
</script>

<style></style>

<section id="relation" class="pt-12 pb-24 bg-gradient-to-t from-gray-100 via-gray-50 to-white">
  <Container>
    <div class="flex flex-col lg:flex-row">
      <div class="lg:w-full px-var">
        <Preview item={img}></Preview>
      </div>
      <div class="px-var py-12 flex flex-col md:flex-row lg:flex-col md:justify-center text-center md:text-left space-y-3 md:space-y-0 md:space-y-3">
        <div class="md:w-2/3 lg:w-full px-var">
          <Text>{message}</Text>
        </div>
        <div class="md:w-1/3 lg:w-full px-var space-y-2">
          <Header>{person}</Header>
          <Meta>{project}</Meta>
        </div>
      </div>
    </div>
  </Container>
</section>